<template>
  <div class="social-tabs">
		<ul class="nav nav-tabs">
			<b-nav-item :to="{ name: socialGroupBy }" title="Content Calendar">
				Content Calendar
			</b-nav-item>
			<b-nav-item :to="{ name: 'socialMediaSchedule' }" title="Scheduled Content">
				Scheduled Content
			</b-nav-item>
		</ul>
	</div>
</template>

<script>
	import { mapGetters } from "vuex";

	export default {
		computed: {
			...mapGetters([
				"socialMediaFilter",
				"socialGroupBy"			
			])
		}
	}
</script>